const ROLE_PERMISSIONS = {
  owner: {
    canUpdateCompany: true,
    canPurchase: true,
    canManageCodes: true,
    canManageMembers: true,
    canViewCodes: true,
    canViewParticipants: true,
    canViewResults: true,
  },
  manager: {
    canUpdateCompany: true,
    canPurchase: true,
    canManageCodes: true,
    canManageMembers: false,
    canViewCodes: true,
    canViewParticipants: true,
    canViewResults: true,
  },
  viewer: {
    canUpdateCompany: false,
    canPurchase: false,
    canManageCodes: false,
    canManageMembers: false,
    canViewCodes: true,
    canViewParticipants: true,
    canViewResults: true,
  },
};

export function resolveCompanyPermissions(membership) {
  const role = membership?.role || membership?.membership_role;
  const defaults = ROLE_PERMISSIONS[role] || {
    canUpdateCompany: false,
    canPurchase: false,
    canManageCodes: false,
    canManageMembers: false,
    canViewCodes: false,
    canViewParticipants: false,
    canViewResults: false,
  };
  const fromApi = membership?.permissions || {};
  return {
    role,
    ...defaults,
    ...fromApi,
  };
}

export function canAccessCompanyRoute(pathname, permissions) {
  if (!permissions) {
    return false;
  }
  if (pathname.startsWith('/company/settings')) {
    return true;
  }
  if (pathname.startsWith('/company/codes')) {
    return permissions.canViewCodes;
  }
  if (pathname.startsWith('/company/participants')) {
    return permissions.canViewParticipants;
  }
  if (pathname.startsWith('/company/purchases')) {
    return permissions.canPurchase || permissions.canViewCodes;
  }
  if (pathname.startsWith('/company/credits')) {
    return permissions.canViewCodes;
  }
  return true;
}
